import { SupplierCompanyMessage } from '../../../../../../types/SupplierCompanyMessage';
import { Text } from '../../../../../cdl/Text/Text';
import { SupplierInfoPopup } from '../../../../../common/CoreDataPopup/SupplierInfoPopup';
import { formatCompanyName } from '../../../../../common/helpers/formatCompanyName.helper';
import { translate } from '../../../../../common/helpers/translate.helper';

import { InvolvedParty } from './InvolvedParty';

interface SupplierPartyProps {
    supplier: SupplierCompanyMessage;
}

export const SupplierParty = ({ supplier }: SupplierPartyProps) => {
    return (
        <InvolvedParty
            label={translate('offer.detail.coreData.supplier')}
            modalContent={<SupplierInfoPopup supplier={supplier} />}
        >
            <Text>
                {formatCompanyName({
                    company: supplier,
                })}
            </Text>
            {supplier.email ? (
                <Text
                    color="foreground.subtle"
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', textWrap: 'nowrap' }}
                >
                    {supplier.email}
                </Text>
            ) : null}
            {supplier.phone ? <Text color="foreground.subtle">{supplier.phone}</Text> : null}
        </InvolvedParty>
    );
};
